import { Translate } from 'next-translate';

import { ID, Lot, LotChanges } from 'types';
import { createDefaultLot } from '@components/bid_request/details/utils';

interface DefaultChangesParams {
  isPriceUpdate?: boolean;
  lots?: Lot[];
  t: Translate;
}

export const defaultChanges = ({ isPriceUpdate = false, lots, t }: DefaultChangesParams): Record<ID, LotChanges> => {
  if (lots?.length) return {};
  // If there are no lots, add an empty lot.
  const newLot = createDefaultLot({ isPriceUpdate, t }) as unknown as LotChanges;

  return { [newLot.id]: newLot };
};
